import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

export default function EditCourse() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    description: "",
    gst: "",
    days: "",
    aboutCourse: "",
    eligibility: "",
    courseIncludes: "",
    courseExcludes: "",
    mainImage: null,
    galleryImages: [],
  });

  const [existingImages, setExistingImages] = useState({
    main: null,
    gallery: [],
  });
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
        const res = await fetch(`${API_BASE_URL}/api/courses/${id}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (!res.ok) throw new Error("Course not found");
        const data = await res.json();
        const arrToText = (arr) => Array.isArray(arr) ? arr.join("\n") : arr || "";
        setFormData({
          name: data.name || "",
          price: data.price || "",
          description: data.description || "",
          gst: data.gst || "",
          days: data.days || "",
          aboutCourse: data.aboutCourse || "",
          eligibility: arrToText(data.eligibility),
          courseIncludes: arrToText(data.courseIncludes),
          courseExcludes: arrToText(data.courseExcludes),
          mainImage: null,
          galleryImages: [],
        });
        setExistingImages({
          main: data.images?.main || data.image || null,
          gallery: data.images?.gallery || [],
        });
      } catch (err) {
        console.error(err.message || "Failed to load course");
      } finally {
        setLoading(false);
      }
    };
    fetchCourse();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "mainImage" && files?.length) {
      setFormData((prev) => ({ ...prev, mainImage: files[0] }));
    } else if (name === "galleryImages") {
      setFormData((prev) => ({ ...prev, galleryImages: Array.from(files) }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (!value) return;
        if (key === "galleryImages") {
          value.forEach((img) => data.append("galleryImages", img));
        } else {
          data.append(key, value);
        }
      });
      const res = await fetch(`${API_BASE_URL}/api/courses/${id}`, {
        method: "PUT",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: data,
      });
      if (!res.ok) throw new Error("Update failed");
      alert("✅ Operational fragment synchronized.");
      navigate("/admin/panel");
    } catch (err) { alert(err.message); }
    finally { setIsSubmitting(false); }
  };

  const getMainPreview = () => {
    if (formData.mainImage) return URL.createObjectURL(formData.mainImage);
    if (existingImages.main) return `${API_BASE_URL}${existingImages.main}`;
    return null;
  };

  if (loading) return (
    <div className="admin-list-container">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh', gap: '20px' }}>
            <div className="loading-spinner"></div>
            <p style={{ fontWeight: 700, color: '#475569' }}>⏳ Fetching Operational Resource Matrix...</p>
        </div>
    </div>
  );

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Resource Synchronization</h1>
        </div>
        <div className="module-badge">Edit Block</div>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
           <div className="admin-user-tag">
              <div className="dot" style={{ background: '#6366f1' }}></div>
              Operator: Curriculum Development Node
           </div>
        </div>

        <div className="admin-table-wrapper" style={{ padding: '40px', background: '#fff' }}>
            <form className="admin-form-elite" onSubmit={handleSubmit}>
                <label>Operational Name <input name="name" value={formData.name} onChange={handleChange} required /></label>
                <label>Unit Price (INR) <input type="number" name="price" value={formData.price} onChange={handleChange} required /></label>
                <label className="full-width-field">Technical Description <textarea name="description" value={formData.description} onChange={handleChange} required /></label>
                <label>Tax Factor (GST) <input name="gst" value={formData.gst} onChange={handleChange} required /></label>
                <label>Block Duration (Days) <input type="number" name="days" value={formData.days} onChange={handleChange} required /></label>
                <label className="full-width-field">About the Curriculum <textarea name="aboutCourse" value={formData.aboutCourse} onChange={handleChange} /></label>
                <label className="full-width-field">Eligibility Matrix <textarea name="eligibility" value={formData.eligibility} onChange={handleChange} /></label>
                <label>Resource Inclusions <textarea name="courseIncludes" value={formData.courseIncludes} onChange={handleChange} /></label>
                <label>Resource Exclusions <textarea name="courseExcludes" value={formData.courseExcludes} onChange={handleChange} /></label>
                <label>Update Primary Asset Image <input type="file" name="mainImage" accept="image/*" onChange={handleChange} /></label>
                <label>Append Gallery Fragments <input type="file" name="galleryImages" accept="image/*" multiple onChange={handleChange} /></label>
                
                <div className="full-width-field" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '20px', marginTop: '20px' }}>
                    {getMainPreview() && (
                        <div style={{ padding: '10px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                            <div style={{ fontSize: '0.65rem', fontWeight: 800, marginBottom: '8px', color: '#64748b' }}>PRIMARY ASSET</div>
                            <img src={getMainPreview()} style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} alt="Preview" />
                        </div>
                    )}
                    {existingImages.gallery.map((img, i) => (
                        <div key={i} style={{ padding: '10px', background: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                            <div style={{ fontSize: '0.65rem', fontWeight: 800, marginBottom: '8px', color: '#64748b' }}>GALLERY #{i+1}</div>
                            <img src={`${API_BASE_URL}${img}`} style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} alt="Gallery" />
                        </div>
                    ))}
                </div>

                <div className="admin-submit-area" style={{ marginTop: '40px' }}>
                   <button type="submit" className="btn-primary-elite" style={{ background: '#6366f1' }} disabled={isSubmitting}>
                      {isSubmitting ? "Synchronizing..." : "CONFIRM SYNC"}
                   </button>
                   <button type="button" className="btn-update" style={{ background: '#f1f5f9', border: 'none', marginLeft: '15px' }} onClick={() => navigate("/admin/panel")}>
                      CANCEL
                   </button>
                </div>
            </form>
        </div>
      </div>
    </div>
  );
}
